import api from "@/lib/api";

export default {
  urlCreate: "/api/v1/stock/items-case/create",
  urlCreateByBarcode: "/api/v1/stock/items-case/create-by-barcode",
  urlDelete: "/api/v1/stock/items-case/delete",
  urlGetAll: "/api/v1/stock/items-case/get-all",
  urlOrderAll: "/api/v1/stock/items-case/order-all",

  async create(caseId, patrimonyId, order) {
    const response = await api.post(this.urlCreate, { caseId, patrimonyId, order });
    return response.data;
  },
  async createByBarcode(caseId, barCode) {
    const response = await api.post(this.urlCreateByBarcode, { any: caseId, value: barCode });
    return response.data;
  },
  async remove(ids) {
    const params = { ids: Array.isArray(ids) ? ids.join(",") : ids };
    const response = await api.delete(this.urlDelete, { params });
    return response.data;
  },
  async getAll(caseId) {
    const response = await api.get(this.urlGetAll, {
      params: { any: caseId, noPaginated: true },
    });
    return response.data;
  },
  async orderAll(listIds) {
    const response = await api.put(this.urlOrderAll, { listIds });
    return response.data;
  },
};
